import Navbar from "../componenets/Navbar";
import Sidebar from "../componenets/Sidebar";
import React, { useState } from 'react';
import swal from "sweetalert";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import useKawasans from "../componenets/useKawasans";

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#596CFF",
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.globizsystems.com/';

function SendMessagesList() {
  const [messageType, setMessageType] = useState('air');
  const [selectedScript, setSelectedScript] = useState('');
  const [accountSearch, setAccountSearch] = useState('');
  const [customers, setCustomers] = useState([]);
  const [areaLocation, setAreaLocation] = useState('');
  const [area, setArea] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const kawasanOptions = useKawasans(messageType);

  const resetResults = () => {
    setSelectedScript('');
    setAccountSearch('');
    setCustomers([]);
    setAreaLocation('');
    setArea([]);
  };

  const changeMessageType = (type) => {
    if (type === messageType) return;
    setMessageType(type);
    resetResults();
  };

  async function findCustomer(event) {
    const account_no = event.target.value.trim();
    setAccountSearch(event.target.value);

    if (!account_no) {
      setCustomers([]);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/messages/get_bills_single_customer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ account_no, type: messageType })
      });

      if (!response.ok) {
        throw new Error('Unable to load successful messages for this account.');
      }

      const responseJson = await response.json();
      setCustomers(responseJson);
    } catch (error) {
      console.error(error);
      setCustomers([]);
      swal('Search failed', error.message, 'error');
    }
  }

  async function findCustomerLocation(event) {
    const kod_kawasan = event.target.value;
    setAreaLocation(kod_kawasan);

    if (!kod_kawasan) {
      setArea([]);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/messages/allsent_messages`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kod_kawasan, type: messageType })
      });

      if (!response.ok) {
        throw new Error('Unable to load successful messages for this area.');
      }

      const responseJson = await response.json();
      setArea(responseJson);
    } catch (error) {
      console.error(error);
      setArea([]);
      swal('Search failed', error.message, 'error');
    }
  }

  function findScript(event) {
    setSelectedScript(event.target.value);
    setAreaLocation('');
    setArea([]);
  }

  const GetAllCustomersByArea = async () => {
    if (!areaLocation) {
      swal({
        title: 'Choose an area first',
        text: 'Select a script and location before downloading the report.',
        icon: 'warning'
      });
      return;
    }

    setIsDownloading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/reports/all_sent_messages_excel`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kod_kawasan: areaLocation, type: messageType })
      });

      if (!response.ok) {
        let message = 'Unable to generate the Excel report.';

        try {
          const errorBody = await response.json();
          message = errorBody.details || errorBody.error || message;
        } catch (error) {
          // The server may return a non-JSON error page.
        }

        throw new Error(message);
      }

      const reportBlob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(reportBlob);
      const link = document.createElement('a');
      const safeAreaName = String(areaLocation)
        .trim()
        .replace(/[^a-zA-Z0-9_-]+/g, '_');

      link.href = downloadUrl;
      link.download = `Successful_Messages_${messageType.toUpperCase()}_${safeAreaName || 'ALL'}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Excel report download failed:', error);
      swal({
        title: 'Download failed',
        text: error.message || 'Unable to generate the Excel report.',
        icon: 'error'
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const renderMessagesTable = (messages) => (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="successful messages table">
        <TableHead>
          <TableRow>
            <StyledTableCell>ID</StyledTableCell>
            <StyledTableCell>NAMA</StyledTableCell>
            <StyledTableCell align="center">
              {messageType === 'sewa' ? 'NO. AKAUN SEWA' : 'NO. AKAUN AIR'}
            </StyledTableCell>
            <StyledTableCell align="center">SENDER NAME</StyledTableCell>
            <StyledTableCell align="center">NO. TELEFON</StyledTableCell>
            {messageType === 'sewa' ? (
              <>
                <StyledTableCell align="center">BAYARAN</StyledTableCell>
                <StyledTableCell align="center">TUNGGAKAN</StyledTableCell>
              </>
            ) : (
              <>
                <StyledTableCell align="center">CURRENT AMOUNT</StyledTableCell>
                <StyledTableCell align="center">TOTAL DUE AMOUNT</StyledTableCell>
              </>
            )}
            <StyledTableCell align="center">DUE DATE</StyledTableCell>
            <StyledTableCell align="center">KAWASAN SEWAAN</StyledTableCell>
            <StyledTableCell align="center">SENT DATE</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {messages?.map((item) => (
            <StyledTableRow key={`${messageType}-${item.id}`}>
              <StyledTableCell>{item.id}</StyledTableCell>
              <StyledTableCell>{item.nama}</StyledTableCell>
              <StyledTableCell align="center">
                {messageType === 'sewa' ? item.no_akaun : item.no_akaun_air}
              </StyledTableCell>
              <StyledTableCell align="center">{item.sender_name}</StyledTableCell>
              <StyledTableCell align="center">
                {messageType === 'sewa' ? item.no_telefon : item.no_telefon_1}
              </StyledTableCell>
              {messageType === 'sewa' ? (
                <>
                  <StyledTableCell align="center">{item.bayaran}</StyledTableCell>
                  <StyledTableCell align="center">{item.tunggakan}</StyledTableCell>
                </>
              ) : (
                <>
                  <StyledTableCell align="center">{item.current_amount}</StyledTableCell>
                  <StyledTableCell align="center">{item.due_amount}</StyledTableCell>
                </>
              )}
              <StyledTableCell align="center">{item.due_date}</StyledTableCell>
              <StyledTableCell align="center">{item.kawasan_sewaan}</StyledTableCell>
              <StyledTableCell align="center">{item.createdAt}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const selectedAreas = selectedScript ? kawasanOptions[selectedScript] || [] : [];
  const typeLabel = messageType === 'sewa' ? 'Sewa' : 'Air';

  return (
    <>
      <Navbar />
      <div className="row">
        <Sidebar />
      </div>
      <main className="main-content position-relative h-100 border-radius-md contained ">
        <div className="container-fluid g-3 ">
          <div className="mx-2 mb-2">
            <Button
              variant={messageType === 'air' ? 'contained' : 'outlined'}
              onClick={() => changeMessageType('air')}
              sx={{ mr: 1 }}
            >
              Air
            </Button>
            <Button
              variant={messageType === 'sewa' ? 'contained' : 'outlined'}
              onClick={() => changeMessageType('sewa')}
            >
              Sewa
            </Button>
          </div>

          <h4 className="colorfix sizefix mx-2">All Successfully Sent Messages</h4>

          <div className="card px-2 pt-3 pb-3 mb-4 cardbg">
            <div className="container-fluid" style={{ backgroundColor: "white" }}>
              <div className="container-fluid px-0 ">
                <div className="col-12">
                  <div className="container-fluid pb-4 pt-3 g-3">
                    <div className="row ">
                      <Box
                        className="row"
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '40ch' } }}
                        noValidate
                        autoComplete="off"
                      >
                        <div className="col-5">
                          <TextField
                            required
                            id="successful-account-search"
                            label={`Search ${typeLabel} bills by Account Number`}
                            value={accountSearch}
                            onChange={findCustomer}
                          />
                        </div>

                        <div className="col-5 mt-2">
                          <FormControl fullWidth>
                            <InputLabel id="successful-script-label">Choose Script</InputLabel>
                            <Select
                              labelId="successful-script-label"
                              id="successful-script"
                              label="Choose Script"
                              value={selectedScript}
                              onChange={findScript}
                            >
                              <MenuItem value="penjaja">Penjaja</MenuItem>
                              <MenuItem value="perumahan">Perumahan</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        {selectedScript && (
                          <div className="col-8 mt-2 mx-2">
                            <FormControl fullWidth>
                              <InputLabel id="successful-location-label">
                                Choose Location ({selectedScript === 'perumahan' ? 'Perumahan' : 'Penjaja'})
                              </InputLabel>
                              <Select
                                labelId="successful-location-label"
                                id="successful-location"
                                label="Choose Location"
                                value={areaLocation}
                                onChange={findCustomerLocation}
                              >
                                {selectedAreas.map((kawasan) => (
                                  <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                    {kawasan.nama_kawasan}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        )}
                      </Box>

                      {accountSearch.trim() && (
                        <div className="mt-3">
                          <legend><b>All Bills Sent to Customer</b></legend>
                          {renderMessagesTable(customers)}
                        </div>
                      )}

                      <div className="mt-4">
                        <legend><b>Total Bills by Area</b></legend>
                        <legend>
                          <Button
                            variant="contained"
                            size="large"
                            onClick={GetAllCustomersByArea}
                            disabled={!areaLocation || isDownloading}
                          >
                            {isDownloading ? 'Preparing report...' : 'Download Excel Report'}
                          </Button>
                        </legend>
                        {renderMessagesTable(area)}
                      </div>

                      <br className="pt-4" />
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default SendMessagesList;
